import { useCurrentFrame, useVideoConfig } from 'remotion';

/**
 * Frame-based build log reveal for Remotion video mode.
 * Returns visible subset of logs based on current frame.
 */
export function useBuildLogAnimation(logs, delayMs = 180) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const framesPerLog = Math.max(1, Math.round((delayMs / 1000) * fps));
  const visibleCount = Math.min(Math.floor(frame / framesPerLog), logs.length);
  return logs.slice(0, visibleCount);
}
